import {InteractionPath} from '@webmate-web-core/shared/types/browsersession';
import {InjectionToken} from '@angular/core';
import { Observable } from 'rxjs';
import {AuditId, ProjectId} from '@webmate-web-core/shared/types/ids';
import {Browser} from '@webmate-web-core/shared/types/browser';

export interface OpenInteractionPathRequest {
    interactionPath: InteractionPath;
    projectId?: ProjectId;
    browser?: Browser;
    auditId?: AuditId;
}

/**
 * Service interface for opening Interaction Paths in a browser session.
 */
export interface InteractionPathOpener {
  open(request: OpenInteractionPathRequest): void;
}

export const INTERACTION_PATH_OPENER =
  new InjectionToken<InteractionPathOpener>('INTERACTION_PATH_OPENER');
